<template>
  <div class="p-4 max-w-lg">
    <h1 class="text-xl font-bold mb-4">Редактирование единицы измерения</h1>
    <div v-if="loading" class="flex justify-center py-10">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
    </div>
    <form v-else @submit.prevent="save" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Полное имя</label>
        <input v-model="form.name" type="text" required class="w-full px-3 py-2 border rounded-md" />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Короткое имя</label>
        <input v-model="form.short_name" type="text" required class="w-full px-3 py-2 border rounded-md" />
      </div>
      <!-- <div>
        <label class="flex items-center">
          <input v-model="form.is_integer" type="checkbox" class="mr-2" />
          <span class="text-sm text-gray-700">Целочисленный учёт</span>
        </label>
      </div> -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">GUID 1С</label>
        <input v-model="form.guid" type="text" :readonly="!!unit?.guid" class="w-full px-3 py-2 border rounded-md bg-gray-50" />
      </div>
      <div class="flex gap-2">
        <button type="submit" class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md">Сохранить</button>
        <router-link :to="{ name: 'ProductUnits' }" class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md">Назад</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductUnitEdit',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      unit: null,
      loading: true,
      form: {
        name: '',
        short_name: '',
        is_integer: false,
        guid: ''
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      axios.post('/api/product-unit/getOne', { id: this.id })
        .then(({ data }) => {
          this.unit = data.data;
          this.form = {
            name: this.unit.name,
            short_name: this.unit.short_name,
            is_integer: this.unit.is_integer || false,
            guid: this.unit.guid || ''
          };
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false; });
    },
    save() {
      axios.post('/api/product-unit/update', { id: this.id, ...this.form })
        .then(() => {
          if (this.$root.$toast?.success) this.$root.$toast.success('Сохранено');
          this.$router.push({ name: 'ProductUnits' });
        })
        .catch(err => {
          if (this.$root.$toast?.error) this.$root.$toast.error(err.response?.data?.message || 'Ошибка');
        });
    }
  }
};
</script>
